export const API_HOST = process.env.REACT_APP_API_HOST || 'https://dev.api.entradasegura.com.br';
export const BOT_HOST = process.env.REACT_APP_BOT_HOST || 'https://api-giuliadev.entradasegura.com.br';
export const ENV = process.env.REACT_APP_ENVIRONMENT || 'development';
export const N8N_ACTIVATION_DETAILS_FLOW_URL = process.env.REACT_APP_N8N_ACTIVATION_DETAILS_FLOW_URL || 'https://dev.n8nwebhook.entradasegura.com.br/webhook/e1383586-cba4-4e48-8a97-92f640fca703';
